import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'admin/components/atoms/Buttons';
import { PartnerClientHeaders, Row, RowCell } from './PartnerClientHeaders';

const ModalWrapper = styled.div`
  width: 1000px;
  max-height: calc(100vh - 210px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
    border-left: solid 1px #ececec;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
    box-shadow: inset 0 0 0 2px #fff;
  }
`;

const CancelButton = styled(Button)`
  background-color: gray;
  margin-left: 10px;
`;

const ConfirmButton = styled(Button)`
  background-color: red;
  margin-left: 10px;
`;

const PartnerClientConfirmModal = ({
  form, onConfirm, onCancel, isUpdate, updateClientSecret,
}) => (
  <ModalWrapper>
    <Row>
      <PartnerClientHeaders keyName="name" />
      <RowCell>{form.name}</RowCell>
    </Row>
    {updateClientSecret !== null
     ? (
       <Row>
         <PartnerClientHeaders keyName="client_secret" />
         <RowCell>{updateClientSecret === true ? '更新する' : '更新しない'}</RowCell>
       </Row>
     )
     : null}
    {isUpdate !== null ? null
     : (
       <Row>
         <PartnerClientHeaders keyName="admin_user" />
         <RowCell>{form.admin_user !== null ? form.admin_user.label : null}</RowCell>
       </Row>
     )}
    <Row>
      <PartnerClientHeaders keyName="description" />
      <RowCell>{form.description}</RowCell>
    </Row>
    <div style={{ textAlign: 'center', margin: 10 }}>
      <CancelButton onClick={onCancel}>キャンセル</CancelButton>
      <ConfirmButton onClick={onConfirm}>実行</ConfirmButton>
    </div>
  </ModalWrapper>
);

PartnerClientConfirmModal.defaultProps = {
  isUpdate: null,
  updateClientSecret: null,
};

PartnerClientConfirmModal.propTypes = {
  form: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  updateClientSecret: PropTypes.bool,
};

export default PartnerClientConfirmModal;
